export var version = 'local';
//# sourceMappingURL=version.js.map